import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b74eec98")

_pushScopeId("data-v-b74eec98")
const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "itemTop" }
const _hoisted_3 = { class: "titleColor" }
const _hoisted_4 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_5 = { class: "dataColor" }
const _hoisted_6 = { class: "itemBottom" }
const _hoisted_7 = { class: "titleColor" }
const _hoisted_8 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_9 = { class: "dataColor" }
const _hoisted_10 = {
  key: 0,
  style: {"position":"absolute","z-index":"2","top":"105px","left":"158px","line-height":"1"}
}
const _hoisted_11 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = {
  class: "itemTop",
  style: {"padding-left":"14px"}
}
const _hoisted_14 = { class: "titleColor" }
const _hoisted_15 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_16 = { class: "dataColor" }
const _hoisted_17 = {
  class: "itemBottom",
  style: {"padding-left":"14px"}
}
const _hoisted_18 = { class: "titleColor" }
const _hoisted_19 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_20 = { class: "dataColor" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "positionDashboardApp" }
const _hoisted_23 = { class: "positionDashboardApp-between" }
const _hoisted_24 = { class: "positionDashboardApp-between-top" }
const _hoisted_25 = { class: "titleFont" }
const _hoisted_26 = { style: {"font-size":"10px","margin-bottom":"0"} }
const _hoisted_27 = { class: "dataFont" }
const _hoisted_28 = { class: "positionDashboardApp-between-bottom" }
const _hoisted_29 = { class: "titleFont" }
const _hoisted_30 = { style: {"font-size":"10px","margin-bottom":"0"} }
const _hoisted_31 = { class: "dataFont" }
const _hoisted_32 = { class: "positionDashboardApp-between" }
const _hoisted_33 = {
  class: "positionDashboardApp-between-top",
  style: {"padding-left":"6px"}
}
const _hoisted_34 = { class: "titleFont" }
const _hoisted_35 = { style: {"font-size":"10px","margin-bottom":"0"} }
const _hoisted_36 = { class: "dataFont" }
const _hoisted_37 = {
  class: "positionDashboardApp-between-bottom",
  style: {"padding-left":"6px"}
}
const _hoisted_38 = { class: "titleFont" }
const _hoisted_39 = { style: {"font-size":"10px","margin-bottom":"0"} }
const _hoisted_40 = { class: "dataFont" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.device==='PC')
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: _ctx.pageType==='Home'?'dashboard':'positionDashboard'
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.t('supplyAndBorrow.supplyBalance')) + " ", 1),
                _createVNode("img", {
                  src: _ctx.informationIcon,
                  height: "14",
                  width: "14"
                }, null, 8, ["src"]),
                _createVNode(_component_q_tooltip, {
                  anchor: "center right",
                  self: "center left"
                }, {
                  default: _withId(() => [
                    _createVNode("span", _hoisted_4, _toDisplayString(_ctx.t('tip.supplyBalanceTip')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode("p", _hoisted_5, _toDisplayString((_ctx.walletAddress==''||_ctx.isLoadingInfo)?'$0.00':_ctx.formatDollars(_ctx.userPoolTotalSupply.toString())), 1)
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", null, [
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t('supplyAndBorrow.netValue')), 1),
                _createVNode("img", {
                  src: _ctx.informationIcon,
                  height: "14",
                  width: "14"
                }, null, 8, ["src"]),
                _createVNode(_component_q_tooltip, {
                  anchor: "center right",
                  self: "center left"
                }, {
                  default: _withId(() => [
                    _createVNode("p", _hoisted_8, _toDisplayString(_ctx.t('tip.netValueTip')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode("p", _hoisted_9, _toDisplayString((_ctx.walletAddress==''||_ctx.isLoadingInfo)?'0.00':_ctx.formatDollars(_ctx.netValue,2)), 1)
            ])
          ]),
          _createVNode("div", {
            style: [{"position":"relative","z-index":"1"}, _ctx.pageType==='Home'?'height: 240px;width: 240px;':'height: 208px;width: 208px;'],
            id: 'dashboardChart'+_ctx.pageType+_ctx.poolType
          }, [
            (_ctx.pageType==='Home')
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode("div", null, [
                    _createVNode("img", {
                      src: _ctx.informationIcon,
                      height: "14",
                      width: "14"
                    }, null, 8, ["src"]),
                    _createVNode(_component_q_tooltip, {
                      anchor: "center right",
                      self: "center left"
                    }, {
                      default: _withId(() => [
                        _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t('tip.borrowRatioTip')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 12, ["id"]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.t('supplyAndBorrow.borrowBalance')) + " ", 1),
                _createVNode("img", {
                  src: _ctx.informationIcon,
                  height: "14",
                  width: "14"
                }, null, 8, ["src"]),
                _createVNode(_component_q_tooltip, {
                  anchor: "center right",
                  self: "center left"
                }, {
                  default: _withId(() => [
                    _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t('tip.borrowBalanceTip')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode("p", _hoisted_16, _toDisplayString((_ctx.walletAddress==''||_ctx.isLoadingInfo)?'$0.00':_ctx.formatDollars(_ctx.userPoolTotalBorrow.toString())), 1)
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", null, [
                _createVNode("span", _hoisted_18, _toDisplayString(_ctx.t('supplyAndBorrow.netAPY')), 1),
                _createVNode("img", {
                  src: _ctx.informationIcon,
                  height: "14",
                  width: "14"
                }, null, 8, ["src"]),
                _createVNode(_component_q_tooltip, {
                  anchor: "center right",
                  self: "center left"
                }, {
                  default: _withId(() => [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                      _createVNode("p", _hoisted_19, _toDisplayString(_ctx.t('tip.netAPRTip')), 1)
                    ], {}, true)
                  ]),
                  _: 3
                })
              ]),
              _createVNode("p", _hoisted_20, _toDisplayString((_ctx.walletAddress==''||_ctx.isLoadingInfo)?'0.00':_ctx.formatBigNumberStr(_ctx.getNetRate(),2)) + "%", 1)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.device==='Mobile')
      ? (_openBlock(), _createBlock("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createTextVNode(_toDisplayString(_ctx.t('supplyAndBorrow.supplyBalance')) + " ", 1),
                  _createVNode("img", {
                    src: _ctx.informationIcon,
                    height: "10",
                    width: "10"
                  }, null, 8, ["src"]),
                  _createVNode(_component_q_tooltip, {
                    "hide-delay": 5000,
                    anchor: "center right",
                    self: "center left"
                  }, {
                    default: _withId(() => [
                      _createVNode("span", _hoisted_26, _toDisplayString(_ctx.t('tip.supplyBalanceTip')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("p", _hoisted_27, _toDisplayString((_ctx.walletAddress==''||_ctx.isLoadingInfo)?'$0.00':_ctx.formatDollars(_ctx.userPoolTotalSupply.toString())), 1)
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode("div", null, [
                  _createVNode("span", _hoisted_29, _toDisplayString(_ctx.t('supplyAndBorrow.netValue')), 1),
                  _createVNode("img", {
                    src: _ctx.informationIcon,
                    height: "10",
                    width: "10"
                  }, null, 8, ["src"]),
                  _createVNode(_component_q_tooltip, {
                    "hide-delay": 5000,
                    anchor: "center right",
                    self: "center left"
                  }, {
                    default: _withId(() => [
                      _createVNode("p", _hoisted_30, _toDisplayString(_ctx.t('tip.netValueTip')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("p", _hoisted_31, _toDisplayString((_ctx.walletAddress==''||_ctx.isLoadingInfo)?'0.00':_ctx.formatDollars(_ctx.netValue,2)), 1)
              ])
            ]),
            _createVNode("div", {
              class: "positionDashboardMobile",
              id: 'dashboardMobile'+_ctx.pageType+_ctx.poolType
            }, null, 8, ["id"]),
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                _createVNode("div", _hoisted_34, [
                  _createTextVNode(_toDisplayString(_ctx.t('supplyAndBorrow.borrowBalance')) + " ", 1),
                  _createVNode("img", {
                    src: _ctx.informationIcon,
                    height: "10",
                    width: "10"
                  }, null, 8, ["src"]),
                  _createVNode(_component_q_tooltip, {
                    "hide-delay": 5000,
                    anchor: "center right",
                    self: "center left"
                  }, {
                    default: _withId(() => [
                      _createVNode("span", _hoisted_35, _toDisplayString(_ctx.t('tip.borrowBalanceTip')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("p", _hoisted_36, _toDisplayString((_ctx.walletAddress==''||_ctx.isLoadingInfo)?'$0.00':_ctx.formatDollars(_ctx.userPoolTotalBorrow.toString())), 1)
              ]),
              _createVNode("div", _hoisted_37, [
                _createVNode("div", null, [
                  _createVNode("span", _hoisted_38, _toDisplayString(_ctx.t('supplyAndBorrow.netAPY')), 1),
                  _createVNode("img", {
                    src: _ctx.informationIcon,
                    height: "10",
                    width: "10"
                  }, null, 8, ["src"]),
                  _createVNode(_component_q_tooltip, {
                    "hide-delay": 5000,
                    anchor: "center right",
                    self: "center left"
                  }, {
                    default: _withId(() => [
                      _renderSlot(_ctx.$slots, "default", {}, () => [
                        _createVNode("p", _hoisted_39, _toDisplayString(_ctx.t('tip.netAPRTip')), 1)
                      ], {}, true)
                    ]),
                    _: 3
                  })
                ]),
                _createVNode("p", _hoisted_40, _toDisplayString((_ctx.walletAddress==''||_ctx.isLoadingInfo)?'0.00':_ctx.formatBigNumberStr(_ctx.getNetRate(),2)) + "%", 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})